import { useEffect, useRef } from 'react'

export const DEFAULT_PAGE_TITLE = 'Lune - Dashboard'

// https://dev.to/luispa/how-to-add-a-dynamic-title-on-your-react-app-1l7k
function useTitle(title?: string, prevailOnUnmount: boolean = false) {
    const defaultTitle = useRef(document.title)

    useEffect(() => {
        if (title) {
            if (title === DEFAULT_PAGE_TITLE) {
                document.title = DEFAULT_PAGE_TITLE
            } else {
                document.title = `${title} | ${DEFAULT_PAGE_TITLE}`
            }
        } else {
            document.title = DEFAULT_PAGE_TITLE
        }
    }, [title])

    useEffect(
        () => () => {
            if (!prevailOnUnmount) {
                document.title = defaultTitle.current
            }
        },
        [prevailOnUnmount],
    )
}

export default useTitle
